import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f71522e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oa-mp-container" }

import {ref} from 'vue'
import OA from './OA.vue'
import MP from './MP.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OMTable',
  setup(__props) {

const activeTab = ref('oa')

const tabs = [
  { label: '公众号台账管理', name: 'oa', component: OA },
  { label: '小程序台账管理', name: 'mp', component: MP }
]

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      type: "card",
      class: "oa-mp-tabs"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
          return _createVNode(_component_el_tab_pane, {
            key: tab.name,
            label: tab.label,
            name: tab.name
          }, null, 8, ["label", "name"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_openBlock(), _createBlock(_KeepAlive, null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(tabs.find(t => t.name === activeTab.value)?.component)))
    ], 1024))
  ]))
}
}

})